module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_2.28527236.jpg";